"use strict";

require("core-js/modules/es.symbol.description.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BuildingWrap = void 0;
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
var _reactRedux = require("react-redux");
var _paulCorePackage = require("paul-core-package");
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _selectors = require("../../redux/selectors");
var _Types = require("../../Types");
var _CardList = require("./CardList");
var _constants = require("../../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const BuildingWrap = _ref => {
  let {
    building
  } = _ref;
  const tV = (0, _paulCorePackage.useTranslationValue)();
  const structure = (0, _reactRedux.useSelector)(_selectors.getComponents) || {};
  const {
    15: tComponents = ''
  } = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getActiveTranslationsInterfaceUILocalizations);
  const {
    HtgSys,
    HtgSub
  } = structure;
  const structureByBuilding = _paulCorePackage.functions.getCurrentStructure({
    structure,
    buildingId: building.id
  }) || {};
  const componentsIdList = Object.values(_objectSpread(_objectSpread({}, structureByBuilding.active), structureByBuilding.byHtgSys)).reduce((acc, item) => [...acc, ...Object.keys(item || {})], []);
  const hasInBuildings = function hasInBuildings() {
    let equipmentsByType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return Object.values(equipmentsByType).some(equipment => equipment.building.includes(building.id));
  };
  const hasHtgSysOrSubInBuilding = hasInBuildings(HtgSys) || hasInBuildings(HtgSub);
  if (!hasHtgSysOrSubInBuilding || !componentsIdList.length) return null;
  const title = "".concat(tComponents, " - ").concat(tV(building === null || building === void 0 ? void 0 : building.thingBuildingStreet), " ").concat(tV(building.thingBuildingHouseNumber));
  return /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    component: "h5",
    variant: "h5",
    sx: {
      fontWeight: 'bold',
      mb: 6,
      color: _constants.colors['main-color-cl-01']
    }
  }, title), /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      display: 'grid',
      gridGap: '85px 40px',
      gridTemplateColumns: 'repeat(auto-fit, 364px)',
      gridAutoFlow: 'dense',
      mb: 10
    }
  }, /*#__PURE__*/_react.default.createElement(_CardList.CardList, {
    componentsIdList: componentsIdList
  })));
};
exports.BuildingWrap = BuildingWrap;
BuildingWrap.propTypes = {
  building: _Types.buildingItemType
};